
import gsap from 'gsap';
import * as THREE from 'three';
import { MeshBasicMaterial } from 'three';
import { MatManager } from '../../data/MatManager';
export class LogoMarkMeshQbg extends THREE.Mesh{

    count:number=0;
    public mat:MeshBasicMaterial;
    blink:number=0;
    brightness:number=1;

    constructor(m:THREE.Mesh){

        let mat = MatManager.getInstance().bigLogoMat;
        super(
            m.geometry,mat
        );
        this.mat = mat;
        this.visible=false;
    }

    show(){
        this.visible=true;
        this.blink=1;
        this.brightness=1;
        gsap.to(this,{
            blink:0,
            duration:0.8,
            ease: "power4.in"
        });
    }

    hide(){
        gsap.to(this,{
            blink:1,
            duration:2,
            brightness:0,
            ease: "linear",
            onComplete: ()=>{this.visible=false;}
        });
    }

    update(){

        if(this.count%2==0){
            this.mat.color.r=this.brightness;
            this.mat.color.g=this.brightness;
            this.mat.color.b=this.brightness;            
        }else{
            this.mat.color.r=this.brightness-0.4*this.blink-0.1;
            this.mat.color.g=this.brightness-0.4*this.blink-0.1;
            this.mat.color.b=this.brightness-0.4*this.blink-0.1;            
        }
        this.count++;

    }

}